import '@amumin/ui-core/tokens.css';
import '@amumin/ui-core/themePacks.css';
// feat/themas: kleuren van de bordthema's, voor de voorbeelden van een bord (Scherm inrichten).
import '@amumin/ui-core/boardThemes.css';
// WP1: merktokens (--b-*) voor app en site; het bord laadt ze niet.
import '@amumin/ui-core/brand.css';
import './design.css';
import './art-dark.css';
// app.css is in WP1 gesplitst; de volgorde blijft gelijk (cascade).
import './styles/shell.css';
import './styles/lists.css';
import './styles/forms.css';
import './styles/legacy.css';
import './compact.css';

import { render } from 'preact';

import { installNativeShell } from '@amumin/platform/capacitor';
import { configureSheetExpand } from '@amumin/ui';

import { App } from './App.js';
import { reloadOnce } from './lib/chunkLoad.js';
import { initPwa } from './lib/push.js';
import { installColorScheme } from './state/colorScheme.js';
import { installDarkArtSwap } from './lib/darkArtSwap.js';
import { installWebHaptics } from './state/haptics.js';
import { installHouseholdTheme } from './state/householdType.js';
import { installPersonalTheme } from './state/personalTheme.js';
import { installAppPictoSet } from './state/pictoSet.js';
import { context, messages } from './state/session.js';

// Oprichter 1 okt: elke sheet krijgt de randknop naar volledig scherm, onthouden per gebruiker
// (deze browser) en per sheet, net als de afspraak-editor.
configureSheetExpand({
  expandLabel: () => messages.value.design.dialog.fullScreen,
  collapseLabel: () => messages.value.design.dialog.smallScreen,
  storageKey: (name) => `fb.sheet.full.${context.value?.identity.id ?? 'anon'}.${name}`,
});

// Na een uitrol bestaan de oude stukjes code niet meer: mislukt een dynamische import (ook buiten
// de routes, zoals de QR-code of het weer), dan één keer vanzelf herladen (lib/chunkLoad.ts).
window.addEventListener('vite:preloadError', () => {
  reloadOnce();
});

// Donkere weergave volgt het systeem; vóór de eerste tekening, dus geen lichte flits.
installColorScheme();
// Donkere illustraties ook zonder CSS-wissel (Firefox; zie lib/darkArtSwap.ts).
installDarkArtSwap();

const root = document.getElementById('app');
if (!root) throw new Error('#app ontbreekt');
render(<App />, root);
// Golf 6b: thema en woorden volgen de soort huishouden (gezin = zoals altijd).
installHouseholdTheme();
installPersonalTheme();
// feat/themas: rustige pictogrammen, tenzij de gebruiker in Mijn thema speels koos.
installAppPictoSet();
// Trillen bij tikken (1 okt): een korte trilling op Android-telefoons (state/haptics.ts).
installWebHaptics();
// iPhone-app (apps/mobile): statusbalk volgt licht/donker, opstartscherm weg na de eerste tekening.
// In een gewone browser doet dit niets.
installNativeShell();
// 0038: service worker (app-schil en meldingen) en de installatieprompt van de browser.
initPwa();
